export default function DspService($http) {
  return {
    getAppnexus
  };

  function getAppnexus(id) {
    return $http.get(`/dsp/appnexus?id=${id}`);
  }
}

DspService.$inject = ['$http'];
